import { useMemo } from 'react'

import {
  LocalStorageUtility,
  SessionStorageUtility,
} from '@Utils/storage/StorageUtility'

export function useLocalStorage(): LocalStorageUtility {
  const localStorage = useMemo(() => new LocalStorageUtility(), [])
  return localStorage
}

export function useSessionStorage(): SessionStorageUtility {
  const sessionStorage = useMemo(() => new SessionStorageUtility(), [])
  return sessionStorage
}
